<div class="question-container" [formGroup]="group" [ngClass]="{active: isSelected, interviewQuestion: interviewMode}">
  <div [ngClass]="isConfigInvalid()?'invalid-question':''">
    <div class="question-header" *ngIf="!interviewMode" (click)="selectQuestion()">
      <button type="button" class="btn btn-link float-start" (click)="expanded = !expanded">
        <i aria-hidden="true" class="fa" [ngClass]="{'fa-angle-right': !expanded, 'fa-angle-down': expanded}"></i>
      </button>
      <span class="question-mapkey">
        {{config.mapKeyName}}
      </span>
      <span class="question-mapkey float-end pe-2">
        {{config.answerTypeName}}
      </span>
    </div>
    <div class="question-body" *ngIf="expanded && !useCondensedView">
      <div class="question-text rendered-quill-content ql-editor-updated" [innerHTML]="questionText"></div>
      <div class="help-text rendered-quill-content ql-editor-updated" [innerHTML]="helpText"
        *ngIf="config.helpText?.length"></div>
      <div class="question-form" data-test-input-type="height">
        <!-- <input type="hidden" matInput [formControlName]="config.id"> -->
        <mat-form-field class="w-40 me-5">
          <mat-label>Feet</mat-label>
          <input type="number" [formControlName]="'feet'+this.config.id" (focus)="onFocus()" matInput (blur)="onBlur()"
            [readonly]="isReadOnly()" data-test-input-part="feet" allowOnlyNumbers>

        </mat-form-field>
        <mat-form-field class="w-40">
          <mat-label>Inches</mat-label>
          <input type="number" [formControlName]="'inch'+this.config.id" (focus)="onFocus()" matInput (blur)="onBlur()"
            [readonly]="isReadOnly()" data-test-input-part="inches" allowOnlyNumbers>
          <mat-error *ngIf="group.get('inch'+this.config.id)?.hasError('min')">Minimum value is 0 inches when feet
            value is present</mat-error>
          <mat-error *ngIf="group.get('inch'+this.config.id)?.hasError('max')">Maximum value is 12 inches when feet
            value is present</mat-error>
        </mat-form-field>
        <div *ngIf="!heightFeatureToggle">
          <mat-error *ngIf="group.get(config.id)?.hasError('required')">required</mat-error>
          <mat-error *ngIf="group.get(config.id)?.hasError('min')">Minimum total value is {{config?.MinInches}}
            inches</mat-error>
          <mat-error *ngIf="group.get(config.id)?.hasError('max')">Maximum total value is {{config?.MaxInches}}
            inches</mat-error>
          <mat-error
            *ngIf="group.get(config.id)?.hasError('validationError')">{{group.get(config.id)?.errors.validationError}}</mat-error>
        </div>
        <div *ngIf="heightFeatureToggle">
          <mat-error *ngIf="group.get(config.id)?.hasError('required')">required</mat-error>
          <mat-error
            *ngIf="(!config.isRequired && (group.get(config.id)?.value !== 0 && group.get(config.id)?.value !== ' ')) && (group.get(config.id)?.hasError('min')) || (config.isRequired && group.get(config.id)?.hasError('min'))">Minimum
            total value is {{config?.MinInches}} inches</mat-error>
          <mat-error
            *ngIf="(!config.isRequired && (group.get(config.id)?.value !== 0 && group.get(config.id)?.value !== ' ')) && (group.get(config.id)?.hasError('max')) || (config.isRequired && group.get(config.id)?.hasError('max'))">Maximum
            total value is {{config?.MaxInches}} inches</mat-error>
          <mat-error
            *ngIf="group.get(config.id)?.hasError('validationError')">{{group.get(config.id)?.errors.validationError}}</mat-error>
        </div>
      </div>
      <app-field-details [question]="config" [form]="group" [readOnlyMode]="isReadOnly()"></app-field-details>
    </div>
    <div class="condensed-view" *ngIf="expanded && useCondensedView">
      <div class="question-form flex flex-row" data-test-input-type="height">
        <mat-form-field class="me-5 w-50" style="justify-content: flex-start;">
          <mat-label [innerHtml]="questionText" class="condensed-label-view"></mat-label>
          <input type="number" [formControlName]="'feet'+this.config.id" (focus)="onFocus()" matInput (blur)="onBlur()"
            [readonly]="isReadOnly()" data-test-input-part="feet" allowOnlyNumbers>
          <mat-hint class="condensed-hint-view">Feet</mat-hint>
        </mat-form-field>
        <div class="flex-1"></div>
        <mat-form-field class="w-50" style="justify-content: flex-end;">
          <mat-label [innerHtml]="" class="condensed-label-view"></mat-label>
          <input type="number" [formControlName]="'inch'+this.config.id" (focus)="onFocus()" matInput (blur)="onBlur()"
            [readonly]="isReadOnly()" data-test-input-part="inches" allowOnlyNumbers>
          <mat-hint class="condensed-hint-view">Inches</mat-hint>
        </mat-form-field>
      </div>
      <div class="flex flex-row condensed-help-text rendered-quill-content " [innerHTML]="helpText"
        *ngIf="config.helpText?.length" style="padding-left: 15px !important;"></div>
      <div style="padding-left: 15px; font-size: 12px;">
        <mat-error *ngIf="group.get('inch'+this.config.id)?.hasError('min')">Minimum value is 0 inches when feet
          value is present</mat-error>
        <mat-error *ngIf="group.get('inch'+this.config.id)?.hasError('max')">Maximum value is 12 inches when feet
          value is present</mat-error>
      </div>
      <div *ngIf="!heightFeatureToggle" style="padding-left: 15px; font-size: 12px;">
        <mat-error *ngIf="group.get(config.id)?.hasError('required')">required</mat-error>
        <mat-error *ngIf="group.get(config.id)?.hasError('min')">Minimum total value is {{config?.MinInches}}
          inches</mat-error>
        <mat-error *ngIf="group.get(config.id)?.hasError('max')">Maximum total value is {{config?.MaxInches}}
          inches</mat-error>
        <mat-error
          *ngIf="group.get(config.id)?.hasError('validationError')">{{group.get(config.id)?.errors.validationError}}</mat-error>
      </div>
      <div *ngIf="heightFeatureToggle" style="padding-left: 15px; font-size: 12px;">
        <mat-error *ngIf="group.get(config.id)?.hasError('required')">required</mat-error>
        <mat-error
          *ngIf="(!config.isRequired && (group.get(config.id)?.value !== 0 && group.get(config.id)?.value !== ' ')) && (group.get(config.id)?.hasError('min')) || (config.isRequired && group.get(config.id)?.hasError('min'))">Minimum
          total value is {{config?.MinInches}} inches</mat-error>
        <mat-error
          *ngIf="(!config.isRequired && (group.get(config.id)?.value !== 0 && group.get(config.id)?.value !== ' ')) && (group.get(config.id)?.hasError('max')) || (config.isRequired && group.get(config.id)?.hasError('max'))">Maximum
          total value is {{config?.MaxInches}} inches</mat-error>
        <mat-error
          *ngIf="group.get(config.id)?.hasError('validationError')">{{group.get(config.id)?.errors.validationError}}</mat-error>
      </div>
      
    </div>
  </div>
</div>